import React, { useState, useEffect } from 'react';
import { RootState } from '../Redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { setAuth } from '../Redux/authSlice';
import axios from 'axios';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Card, Breadcrumb, Pagination } from 'react-bootstrap';
import  "./purchase.css"

interface PurchaseReturn {
    id: number;
    purchase: number;
    product: number;
    purchase_name:string;   
    quantity: number;
    return_reason: string; // updated from "reason"
    date_returned: string;
    total_refund: string;
    return_approved: boolean;
    product_name: string; // optional if you want to display product name
    sales_name: string; // optional if you want to display sales name
}

export default function PurchaseReturnComponent() {
    const [purchaseReturns, setPurchaseReturns] = useState<PurchaseReturn[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedReturn, setSelectedReturn] = useState<PurchaseReturn | null>(null);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [searchTerm, setSearchTerm] = useState<string>('');

    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth.value);

    const getCookie = (name: string) => {
        const cookieName = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');
        for (let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(cookieName) === 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }
        return '';
    };

    const fetchData = async () => {
        try {
            const token = getCookie('token');
            if (!token) {
                dispatch(setAuth(false));
                return;
            }
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const userResponse = await axios.get('https://api.sominnovations.xyz/users/user', {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            dispatch(setAuth(true));
        } catch (e) {
            dispatch(setAuth(false));
        }
    };

    const fetchPurchaseReturns = async (page: number) => {
        setLoading(true);
        try {
            const response = await axios.get(`https://api.sominnovations.xyz/Branches/purchase-returns/?page=${page}&search=${searchTerm}`, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            setPurchaseReturns(response.data.results);
            setTotalPages(Math.ceil(response.data.count / 20));
        } catch (error) {
            console.error('Error fetching purchase returns:', error);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [dispatch]);

    useEffect(() => {
        if (auth) {
            fetchPurchaseReturns(currentPage);
        }
    }, [auth, currentPage, searchTerm]);

    const handleView = (purchaseReturn: PurchaseReturn) => {
        setSelectedReturn(purchaseReturn);
        setShowModal(true);
    };

    const handleDelete = async (id: number) => {
        const confirmed = window.confirm("Are you sure you want to delete this purchase return?");
        if (confirmed) {
            try {
                await axios.delete(`https://api.sominnovations.xyz/Branches/purchase-returns/${id}/`, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                setPurchaseReturns(purchaseReturns.filter((purchaseReturn) => purchaseReturn.id !== id));
            } catch (error) {
                console.error("Error deleting purchase return:", error);
            }
        }
    };

    return (
        <div className="container-return mt-1" style={{padding: "20px"}}>
            <Card className="mb-4">
                <Card.Header style={{ backgroundColor: '#5271ff', color: '#fff' }}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h4>Purchase Returns</h4>
                        <Breadcrumb>
                            <Breadcrumb.Item href="dashboard" > <p style={{color:"white", textDecoration:"none"}}>Dashboard</p> </Breadcrumb.Item>
                            <Breadcrumb.Item active>Purchase Returns</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </Card.Header>
                <Card.Body>
                    <div className="mb-4">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search Purchase Returns..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </Card.Body>
            </Card>

            {loading ? (
                <div>Loading...</div>
            ) : (
                <>
                <div className='table-responsive-sm'>
                    <table className="table table-striped table-responsive table-sm" style={{ fontSize: '14px', margin: 'auto' }}>
                        <thead className="table-dark">
                            <tr>
                                <th>ID</th>
                                <th>Purchase</th>
                                <th>Product</th>
                                <th>Quantity</th>
                                <th>Return Reason</th>
                                <th>Date Returned</th>
                                <th>Total Refund</th>
                                <th>Return Approved</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {purchaseReturns.map((purchaseReturn) => (
                                <tr key={purchaseReturn.id}>
                                    <td>{purchaseReturn.id}</td>
                                    <td>{purchaseReturn.purchase_name}</td>
                                    <td>{purchaseReturn.product_name}</td>
                                    <td>{purchaseReturn.quantity}</td>
                                    <td>{purchaseReturn.return_reason}</td>
                                    <td>{new Date(purchaseReturn.date_returned).toLocaleDateString()}</td>
                                    <td>{purchaseReturn.total_refund}</td>
                                    <td>{purchaseReturn.return_approved ? "Yes" : "No"}</td>
                                    <td>
                                        <Button variant="info" size="sm" onClick={() => handleView(purchaseReturn)}>
                                            View
                                        </Button>
                                        <Button variant="danger" size="sm" onClick={() => handleDelete(purchaseReturn.id)} className="mx-1">
                                            Delete
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    </div>

                    <Pagination>
                        {Array.from({ length: totalPages }).map((_, i) => (
                            <Pagination.Item key={i} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
                                {i + 1}
                            </Pagination.Item>
                        ))}
                    </Pagination>
                </>
            )}

            {selectedReturn && (
                <Modal show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>View Purchase Return</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p><strong>Purchase ID:</strong> {selectedReturn.purchase}</p>
                        <p><strong>Product ID:</strong> {selectedReturn.product}</p>
                        <p><strong>Quantity:</strong> {selectedReturn.quantity}</p>
                        <p><strong>Return Reason:</strong> {selectedReturn.return_reason}</p>
                        <p><strong>Date Returned:</strong> {new Date(selectedReturn.date_returned).toLocaleDateString()}</p>
                        <p><strong>Total Refund:</strong> {selectedReturn.total_refund}</p>
                        <p><strong>Return Approved:</strong> {selectedReturn.return_approved ? "Yes" : "No"}</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </div>
    );
}
